import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";

class EidPin extends Component {

    render() {
        if (!this.props.cardInserted)
            return null;

        return (
            <div id="eid-pin">
                {!this.props.externalPinPad ? (
                    <Fragment>
                        <label htmlFor="eid-pin">{window.eidMessages.pinCode}</label>
                        <input id="eid-pin-input" type="password" value={this.props.pin}
                               onChange={(e) => this.props.onPinChange(e.target.value)}
                               onKeyPress={(e) => { if (e.key === 'Enter' && this.isPinSubmitEnabled()) {
                                   this.props.onLogin();
                               } }}
                               autoFocus={true}
                        />
                    </Fragment>
                ) : (
                    <label>{window.eidMessages.externalPinPad}</label>
                )}
                <input id="eid-pin-submit" className="btn" type="submit" value={window.eidMessages.login}
                       disabled={!this.isPinSubmitEnabled() || !this.props.cardFullyRead || this.props.loginBusy || this.props.loginSuccess} onClick={(e) => { e.preventDefault(); this.props.onLogin() }}/>
            </div>
        )
    }

    isPinSubmitEnabled() {
        return this.props.pin.length >= 4 || this.props.externalPinPad;
    }

}

export default connect(
    (state) => {
        return {
            cardInserted: state.eid.inserted,
            externalPinPad: state.eid.externalPinPad,
            loginBusy: state.eid.loginBusy,
            cardFullyRead: state.eid.cardFullyRead,
            pin: state.eid.pin,
            loginSuccess: state.eid.loginSuccess
        }
    },
    (dispatch) => {
        return {
            onPinChange: (pin) => {
                dispatch({
                    type: 'EID_PIN_CHANGE',
                    pin
                })
            },
            onLogin: () => {
                dispatch({
                    type: 'PERFORM_LOGIN'
                })
            }
        }
    }
)(EidPin);


// WEBPACK FOOTER //
// ./src/components/EidPin.js